module.exports = __webpack_public_path__ + "img/6.5518216d.jpg";